class Auth {
  authenticated = false;
  key = "Saras_Blog_Admin";
  tokenKey = "Saras_Blog_Token";
   getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  login(data, token) {
    if (!data || !token) {
      this.authenticated = false;
      return false; // Prevent login if data or token is missing
    }
    document.cookie=`${this.tokenKey}=${token}`
    // ${this.tokenKey}=
    localStorage.setItem(this.key, JSON.stringify(data));
    localStorage.setItem(this.tokenKey, token);

    this.authenticated = true;
    return true;
  }

  userInfo() {
    try {
      const user = JSON.parse(localStorage.getItem(this.key));
      return user?.data?.userInfo || null;
    } catch (error) {
      return null;
    }
  }

  token() {
   
   const value= this.getCookie(this.tokenKey)
    const token =value
    return token;
  }

  logout() {
    document.cookie=`null`
    localStorage.clear();
    this.authenticated = false;
  }

  isUserAuthenticated() {
    return localStorage.getItem(this.key) ? true : false;

  }
}

export default new Auth();
